import API from '@/api/path'
import { baseFetch } from '@/api/axiosBase'

const deviceModule = {
  state: {
    deviceList: [],
    devicePermissionOptions: [
      {
        label: '無',
        value: '0'
      },
      {
        label: '公區',
        value: '1'
      },
      {
        label: '指定棟別',
        value: '2'
      },
      {
        label: '指定棟別與樓層',
        value: '3'
      },
    ]
  },
  actions: {
    // 取得設備列表
    async fetchDeviceList({ commit, rootState }, searchParams) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      try {
        const res = await baseFetch(
          API.getDeviceList.url,
          API.getDeviceList.method, 
          {
            ...searchParams,
            models: '',
            commulityId: currentCommunityId
          }
        )
        if (!res.isError && res.data) {
          // console.log('nvrData:'+JSON.stringify(res.data))
          commit('SET_DEVICE_LIST', res.data.data)
        }
      } catch (error) {
        console.error('error', error)
      }
    },
    // 更新設備
    async updateDeviceById(_, { deviceId, ...bodyData }) {
      // 回到頁面處理
      return baseFetch(
        API.updateDeviceById.url(deviceId),
        API.updateDeviceById.method,
        bodyData
      )
    },
    // 更新設備attrs
    async updateDeviceAttrsById(_, { deviceId, ...bodyData }) {
      // 回到頁面處理
      return baseFetch(
        API.updateDeviceAttrsById.url(deviceId),
        API.updateDeviceAttrsById.method,
        bodyData
      )
    },
    // 更新設備
    async setSwById(_, { deviceId, ...bodyData }) {
      // 回到頁面處理
      return baseFetch(
        API.setSw.url(deviceId),
        API.setSw.method,
        bodyData
      )
    },
    // 回傳取得設備列表
    returnGetDeviceList({ rootState }, searchParams) {
      const currentCommunityId = rootState.commonModule.currentCommunityId
      return baseFetch(
        API.getDeviceList.url,
        API.getDeviceList.method, 
        {
          ...searchParams,
          commulityId: currentCommunityId
        }
      )
    },
  },
  mutations: {
    SET_DEVICE_LIST(state, payload) {
      state.deviceList = payload
    },
  },
  getters: {
    getDeviceList: (state) => state.deviceList,
    getDevicePermissionOptions: (state) => state.devicePermissionOptions
  },
  namespaced: true
}

export default deviceModule